window.market = "";
window.currency = "";
window.currencySymbol = "";
window.marketVatRate = 0;
window.domain = "";
window.checkoutSession = "";

window.priceSubtotal = 0;
window.priceDiscount = 0;
window.priceShipping = 0;
window.pricePayment = 0;
window.priceTip = 0;
window.priceTotal = 0;

window.order = {};

window.vatSubtotal = 0;
window.vatDiscount = 0;
window.vatShipping = 0;
window.vatPayment = 0;
window.vatTip = 0;
window.vatTotal = 0;

window.discountCode = "";
window.discountStatus = "";
window.discountMinOrder = 0;

// Function to map currency codes to symbols and store them in 'currencySymbol'
const setCurrencySymbol = () => {
  const currencyCode = getNCookie("n_currency") || "";

  switch (currencyCode) {
    case "CZK":
      currencySymbol = "Kč";
      break;
    case "EUR":
      currencySymbol = "€";
      break;
    case "USD":
      currencySymbol = "$";
      break;
    case "GBP":
      currencySymbol = "£";
      break;
    case "AUD":
      currencySymbol = "A$";
      break;
    case "CAD":
      currencySymbol = "C$";
      break;
    case "JPY":
      currencySymbol = "¥";
      break;
    case "INR":
      currencySymbol = "₹";
      break;
    case "CHF":
      currencySymbol = "Fr";
      break;
    default:
      currencySymbol = ""; // Default to an empty string if the currency isn't listed
  }
};

/* 
Checkout session handeling
*/

// Function to get a cookie by name
const getNCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
};

// Function to set a cookie
const setNCookie = (name, value, days) => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
};

// Function to remove a specified cookie by name
function removeNCookie(cookieName) {
  document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  console.log(`${cookieName} cookie removed`);
}

function setLoading () {
  const i = document.getElementById("checkoutLoading");
  i.classList.add("visible");
}

function removeLoading () {
  const i = document.getElementById("checkoutLoading");
  i.classList.remove("visible");
}

/*
Cookie handeling
*/

// Function to store values in the variables from cookies
const storeSessionValues = () => {
  market = getNCookie("n_market") || "";
  marketVatRate = parseFloat(getNCookie("n_marketVatRate")) || 21;
  currency = getNCookie("n_currency") || "";
  domain = getNCookie("n_domain") || "";
  const urlParams = new URLSearchParams(window.location.search);
  const sessionID = urlParams.get("nchk");
  checkoutSession = sessionID;
};

/* 
Pricing handeling
*/

// Function to apply the currency symbol, divide price by 100, format it, and separate thousands with spaces
const applyMoneyFilter = () => {
  const currencySymbolPlace = getNCookie("n_currencySymbol-place") || "before"; // 'before' or 'after'

  // Find all elements with the class 'filter-money'
  document.querySelectorAll(".filter-money").forEach((element) => {
    let price = parseFloat(element.textContent.trim()); // Get the price and convert it to a number

    // Divide the price by 100
    price = price / 100;

    // Format the price and separate thousands by space
    let formattedPrice =
      price % 1 === 0
        ? price
            .toLocaleString("en-US", { minimumFractionDigits: 0 })
            .replace(/,/g, " ")
        : price
            .toLocaleString("en-US", { minimumFractionDigits: 2 })
            .replace(/,/g, " ");

    // Place the currency symbol either before or after the price based on the cookie
    if (currencySymbolPlace === "after") {
      element.textContent = `${formattedPrice} ${currencySymbol}`;
    } else {
      element.textContent = `${currencySymbol} ${formattedPrice}`;
    }
  });
};

// Function to update priceTotal
const updatePriceTotal = () => {
  priceTotal = priceSubtotal - priceDiscount + priceShipping + pricePayment + priceTip;
  vatTotal = vatSubtotal - vatDiscount + vatShipping + vatPayment + vatTip;

  document.querySelectorAll(".dataSubtotal").forEach((element) => {
    element.textContent = priceSubtotal;
  });

  document.querySelectorAll(".dataShipping").forEach((element) => {
    element.textContent = priceShipping;
  });

  document.querySelectorAll(".dataPayment").forEach((element) => {
    element.textContent = pricePayment;
  });

  document.querySelectorAll(".dataDiscount").forEach((element) => {
    element.textContent = priceDiscount;
  });

  document.querySelectorAll(".dataTip").forEach((element) => {
    element.textContent = priceTip;
  });

  document.querySelectorAll(".dataTotal").forEach((element) => {
    element.textContent = priceTotal;
  });
};

// Function to update pricing variables
const setPriceSubtotal = (newSubtotal) => {
  priceSubtotal = newSubtotal;
  vatSubtotal = (newSubtotal * marketVatRate) / 100;
  updatePriceTotal();
};

const setPriceDiscount = (newDiscount) => {
  priceDiscount = newDiscount;
  vatDiscount = (newDiscount * marketVatRate) / 100;
  updatePriceTotal();
};

const setPriceShipping = (newShipping) => {
  priceShipping = newShipping;
  vatShipping = (newShipping * marketVatRate) / 100;
  updatePriceTotal();
};

const setPricePayment = (newPayment) => {
  pricePayment = newPayment;
  vatPayment = (newPayment * marketVatRate) / 100;
  updatePriceTotal();
};

const setPriceTip = (newTip) => {
  priceTip = newTip;
  vatTip = (newTip * marketVatRate) / 100;
  updatePriceTotal();
};

function updateSummaryVisibility() {
  // Check for pricePayment and add .active to .summary_line-payment if needed
  if (typeof pricePayment !== "undefined" && pricePayment > 1) {
    document
      .querySelectorAll(".summary_line-payment")
      .forEach(function (element) {
        element.classList.add("active");
      });
  } else {
    document
      .querySelectorAll(".summary_line-payment")
      .forEach(function (element) {
        element.classList.remove("active");
      });
  }

  // Check for priceDiscount and add .active to .summary_line-discount if needed
  if (typeof priceDiscount !== "undefined" && priceDiscount > 1) {
    document
      .querySelectorAll(".summary_line-discount")
      .forEach(function (element) {
        element.classList.add("active");
      });
  } else {
    document
      .querySelectorAll(".summary_line-discount")
      .forEach(function (element) {
        element.classList.remove("active");
      });
  }

  // Check for priceDiscount and add .active to .summary_line-discount if needed
  if (typeof priceTip !== "undefined" && priceTip > 1) {
    document
      .querySelectorAll(".summary_line-tip")
      .forEach(function (element) {
        element.classList.add("active");
      });
  } else {
    document
      .querySelectorAll(".summary_line-tip")
      .forEach(function (element) {
        element.classList.remove("active");
      });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const summaryDrawer = document.querySelector(
    ".n_checkout-system-mobile_summary--drawer-total"
  );
  const cartSummary = document.querySelector(
    ".n_checkout-system-mobile_summary--cart"
  );

  if (summaryDrawer && cartSummary) {
    summaryDrawer.addEventListener("click", function () {
      // Toggle the 'visible' class to expand or collapse the cart
      cartSummary.classList.toggle("visible");

      // Optional: toggle arrow icon direction
      const arrowIcon = summaryDrawer.querySelector("svg");
      if (cartSummary.classList.contains("visible")) {
        arrowIcon.style.transform = "rotate(180deg)"; // Arrow pointing up when open
      } else {
        arrowIcon.style.transform = "rotate(0deg)"; // Arrow pointing down when closed
      }
    });
  }
});

/*
Retrieving the order
*/

// Function to retrieve order status by order hash
const retrieveOrderStatus = async (orderHash) => {
  try {
    // Perform POST request to retrieve the order
    const response = await fetch(`/a/api/status/retrieveorder`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        order: orderHash,
      }),
    });

    if (!response.ok) {
      throw new Error(`Error retrieving order: ${response.statusText}`);
    }

    const orderData = await response.json();
    window.order = orderData;
    console.log(orderData);

    updateOrderDetails(orderData);

    
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("npt") === "true") {
      window.sendPurchaseEvent(orderData);
    }

    
  } catch (error) {
    console.error("Failed to retrieve order status:", error);
  }
};

// Function to update order details on the page
const updateOrderDetails = (orderData) => {
  displayOrderStatus(orderData);
  displayBankTransferRequest(orderData);
  displayPaymentFailedRequest(orderData);

  // Update pricing details
  setPriceSubtotal(orderData.pricing.priceSubtotal * 100);
  setPriceDiscount(orderData.pricing.priceDiscount * 100);
  setPriceShipping(orderData.pricing.priceShipping * 100);
  setPricePayment(orderData.pricing.pricePayment * 100);
  setPriceTip(orderData.pricing.priceTip * 100);

  // Update customer contact details
  document.querySelectorAll(".import-order_number").forEach((element) => {
    element.textContent = orderData.order.name || "";
  });

  document.querySelectorAll(".import-order_date").forEach((element) => {
    element.textContent = orderData.order.date || "";
  });

  document.querySelectorAll("#rDataEmail").forEach((element) => {
    element.textContent = orderData.customer.email || "";
  });

  document.querySelectorAll("#rDataPhone").forEach((element) => {
    element.textContent = orderData.customer.phone || "";
  });

  // Update billing details
  document.querySelectorAll("#rDataBillingFullName").forEach((element) => {
    element.textContent = `${orderData.billing_address.firstName || ""} ${
      orderData.billing_address.lastName || ""
    }`.trim();
  });

  document.querySelectorAll("#rDataBillingLastName").forEach((element) => {
    element.textContent = orderData.billing_address.lastName || "";
  });

  document.querySelectorAll("#rDataBillingAddress").forEach((element) => {
    element.textContent = orderData.billing_address.address || "";
  });

  document.querySelectorAll("#rDataBillingZip").forEach((element) => {
    element.textContent = orderData.billing_address.zip || "";
  });

  document.querySelectorAll("#rDataBillingCity").forEach((element) => {
    element.textContent = orderData.billing_address.city || "";
  });

  document.querySelectorAll("#rDataBillingCountry").forEach((element) => {
    element.textContent = orderData.billing_address.countryName || "";
  });

  // Update shipping details
  document.querySelectorAll("#rDataShippingFullName").forEach((element) => {
    element.textContent = `${orderData.shipping_address.firstName || ""} ${
      orderData.shipping_address.lastName || ""
    }`.trim();
  });

  document.querySelectorAll("#rDataShippingAddress").forEach((element) => {
    element.textContent = orderData.shipping_address.address || "";
  });

  document.querySelectorAll("#rDataShippingZip").forEach((element) => {
    element.textContent = orderData.shipping_address.zip || "";
  });

  document.querySelectorAll("#rDataShippingCity").forEach((element) => {
    element.textContent = orderData.shipping_address.city || "";
  });

  document.querySelectorAll("#rDataShippingCountry").forEach((element) => {
    element.textContent = orderData.shipping_address.countryName || "";
  });
  
  // Update bank details
  
  document.querySelectorAll("#rDataBankAccount").forEach((element) => {
    element.textContent = orderData.payment_method.bank_account || "";
  });

  document.querySelectorAll("#rDataVarSymbol").forEach((element) => {
    element.textContent = orderData.payment_method.var_symbol || "";
  });

  document.querySelectorAll("#rDataAmount").forEach((element) => {
    element.textContent = orderData.payment_method.amount || "";
  });

  document.querySelectorAll("#rDataPaymentQr").forEach((element) => {
  element.src = orderData.payment_method.payment_qr;
});


  // Update other things

  document.querySelectorAll("#rDataShippingMethod").forEach((element) => {
    const pointName = orderData.shipping_method.pointName || "";
    element.textContent = `${
      orderData.shipping_method.shippingMethodName || ""
    }${pointName ? ` (${pointName})` : ""}`.trim();
  });

  document.querySelectorAll("#rDataPaymentMethod").forEach((element) => {
    element.textContent = orderData.payment_method.paymentMethodName || "";
  });

  // Update cart items in all containers
  const cartContainers = document.querySelectorAll(".import-cart_container");
  if (cartContainers.length > 0) {
    cartContainers.forEach((container) => {
      container.innerHTML = ""; // Clear any existing cart items
      orderData.cart.forEach((item) => {
        const cartItemHTML = `
          <div class="n_checkout-system--cart_item--container">
            <div class="cart_item--content">
              <div class="cart_item--image">
                <img class="import-item_image" src="${item.image_url}" alt="${
          item.title
        }">
              </div>
              <div class="cart_item--info">
                <span class="cart_item--title import-item_title">${
                  item.title
                }</span>
                <span class="cart_item--variant">Velikost: <span class="import-item_variant-title">${
                  item.variant_title
                }</span></span>
                <span class="cart_item--quantity">Množství: <span class="import-item_quantity">${
                  item.quantity
                }</span></span>
              </div>
            </div>
            <div class="cart_item--pricing_container">
              <span class="cart_item--line_price import-item_price filter-money">${
                item.line_price * 100
              }</span>
            </div>
          </div>
        `;
        container.insertAdjacentHTML("beforeend", cartItemHTML);
      });
    });
  }
};

const displayOrderStatus = (orderData) => {
  // Hide all elements with the class 'order-status' initially
  document.querySelectorAll(".order-status").forEach((element) => {
    element.style.display = "none";
  });

  // Get the current URL
  const urlParams = new URLSearchParams(window.location.search);
  const paymentStatus = urlParams.get("paymentStatus");

  // Set the status based on the paymentStatus parameter
  let status;
  if (paymentStatus) {
    const paidStatuses = ["4", "7", "8"];
    const unpaidStatuses = ["0", "1", "2", "3", "5", "6"];
    if (paidStatuses.includes(paymentStatus)) {
      status = "paid";
    } else if (unpaidStatuses.includes(paymentStatus)) {
      status = "unpaid";
    }
  } else {
    // Default to the orderData status if paymentStatus is not in the URL
    status = orderData.order.status;
  }

  // Display the matching status element by ID if it exists
  const statusElement = document.getElementById(status);
  if (statusElement) {
    statusElement.style.display = "flex";
  }
};

const displayBankTransferRequest = (orderData) => {
  // Get the container element by its ID
  const bankTransferContainer = document.getElementById("bank_transfer_request");

  if (!bankTransferContainer) {
    console.error("Element with id 'bank_transfer_request' not found.");
    return;
  }

  // Check if the payment method is "bank_transfer" and the order status is not "paid"
  const isBankTransfer = orderData.payment_method?.paymentMethod === "bank_transfer";
  const isNotPaid = orderData.payment_method?.payment_status === "unpaid";

  if (isBankTransfer && isNotPaid) {
    // Display the container if both conditions are met
    bankTransferContainer.style.display = "flex";
  } else {
    // Hide the container otherwise
    bankTransferContainer.style.display = "none";
  }
};

const displayPaymentFailedRequest = (orderData) => {
  // Get the container element by its ID
  const paymentFailedRequest = document.getElementById("gateway_payment_failed");

  if (!paymentFailedRequest) {
    console.error("Element with id 'gateway_payment_failed' not found.");
    return;
  }

  // Check for the 'paymentStatus' parameter in the URL
  const urlParams = new URLSearchParams(window.location.search);
  const paymentStatus = urlParams.get("paymentStatus");

  // Define the unpaid statuses
  const unpaidStatuses = ["0", "1", "2", "3", "5", "6"];

  // Check if the payment method is "gateway"
  const isGateway = orderData.payment_method?.paymentMethod === "gateway";

  if (!isGateway) {
    // If payment method is not "gateway", hide the container and exit
    paymentFailedRequest.style.display = "none";
    return;
  }

  // Determine visibility based on the presence of 'paymentStatus' or fallback
  if (paymentStatus !== null) {
    // Use the URL parameter condition
    if (unpaidStatuses.includes(paymentStatus)) {
      paymentFailedRequest.style.display = "flex";
    } else {
      paymentFailedRequest.style.display = "none";
    }
  } else {
    // Fallback to check `orderData.payment_method.payment_status`
    if (orderData.payment_method?.payment_status === "unpaid") {
      paymentFailedRequest.style.display = "flex";
    } else {
      paymentFailedRequest.style.display = "none";
    }
  }
};

document.getElementById('reinitiatePaymentBtn').addEventListener('click', () => {
  const paymentData = {
    orderHash: window.order.session.orderHash,
    orderNo: window.order.order.name,
    amount: window.order.pricing.priceTotal * 100,
    currency: window.order.session.currency,
    language: window.order.session.language || "cs",
    returnUrl: `https://${window.domain}/pages/status?nox=${window.order.session.orderHash}`,
    returnMethod: `GET`,
  };

  // Call the function with the order data
  console.log(paymentData);
  reinitiatePayment(paymentData);
});


async function reinitiatePayment(paymentData) {
  setLoading();
  try {
    // Call the reinitiate-payment API
    const response = await fetch('/a/api/reinitiate-payment', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(paymentData), // Pass the order data as required
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }

    const data = await response.json();

    if (!data.redirectUrl) {
      throw new Error('Redirect URL is missing in the API response.');
      removeLoading ();
    }

    // Redirect to the payment gateway
    window.location.href = data.redirectUrl;
  } catch (error) {
    console.error('Error during payment reinitiation:', error.message);
    alert('Payment could not be initiated. Please try again.');
    removeLoading ();
  }
}

/*
Performance tracking data layer
*/

function handlePurchaseEvent(orderData) {
  // Prepare the data object to pass to sendPurchaseEvent
  const data = {
    customer: {
      email: orderData.customer.email,
      phone: orderData.customer.phone,
      first_name: orderData.billing_address.firstName,
      last_name: orderData.billing_address.lastName,
      address: orderData.billing_address.address,
      city: orderData.billing_address.city,
      zip: orderData.billing_address.zip,
    },
    transaction_id: orderData.order.id,
    value: orderData.pricing.priceSubtotal - orderData.pricing.vatSubtotal,
    currency: orderData.session.currency,
    tax: orderData.pricing.vatSubtotal,
    shipping: orderData.pricing.priceShipping - orderData.pricing.vatShipping,
    items: orderData.cart.map((item) => ({
      item_id: item.variant_id,
      item_name: item.title,
      price: item.price - item.price_vat,
      quantity: item.quantity,
      item_category: "", // Populate this if you have categories
    })),
  };

  // Call the sendPurchaseEvent function with the prepared data
  sendPurchaseEvent(data);

  console.log("sendPurchaseEvent called with:", data);
}

/* 
Applying the functions
*/

document.addEventListener("DOMContentLoaded", async (event) => {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const orderHash = urlParams.get("nox");

    // Step 1: Retrieve order status
    await retrieveOrderStatus(orderHash);

    // Step 2: Set currency symbol
    await setCurrencySymbol();

    // Step 3: Store session values
    await storeSessionValues();

    // Step 4: Apply money filter
    await applyMoneyFilter();

    // Step 5: Update summary visibility
    await updateSummaryVisibility();

    // Step 6: Wait 500ms, then remove the loading placeholder
    await new Promise((resolve) => setTimeout(resolve, 500));
    await removeLoading();
    
  } catch (error) {
    console.error("Error during initialization:", error);
  }
});

